import _ from 'lodash'
import Nav from 'scoreboard/components/nav'
import Chart from './model/chart'
import NewTab from 'scoreboard/components/new-tab'
import permissions from 'scoreboard/components/permissions'

var ChartsNav = Nav.extend({
	section: 'charts',
	Model: Chart,

	events: _.extend({}, Nav.prototype.events, NewTab.events),

	isEditable: function(orgId) {
		// permissions.reports is the "modify charts and reports" permission
		return permissions.reports(orgId)
	}

})

_.extend(ChartsNav.prototype, _.omit(NewTab, 'events'))

export default ChartsNav

ChartsNav.__filename__ = 'charts/charts-nav.js'
